import {Component, Input} from '@angular/core';
import {NgxJsonViewerModule} from 'ngx-json-viewer'

@Component({
  selector: 'app-modal-json',
  templateUrl: './modal-json.component.html',
  imports: [
    NgxJsonViewerModule
  ]
})
export class ModelJsonComponent {
  @Input() tokens: string;
}
